import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import JobGroupAPI from '../../../../utils/api/JobGroupAPI';

const entity = new ReduxRestEntity({
  name: 'jobGroups',
  api: JobGroupAPI(),
});

export default entity;
